import axios from 'axios'
import axiosAdapterUniapp from 'axios-adapter-uniapp'
import {
	basePath
} from '@/api'
//创建axios的一个实例
var instance = axios.create({



	baseURL: '',
	timeout: 6000
})
// 获取本地缓存数据
var getVal = function(val) {
	let result = uni.getStorageSync(val)
	// uni.webView.getEnv(function(res) {
	// 	if (res.plus) {
	// 		result = plus.storage.getItem(val);
	// 		if (val != 'access_token' && val != 'refresh_token') {
	// 			result = JSON.parse(result).data
	// 		}
	// 	} else {
	// 		result = uni.getStorageSync(val)
	// 	}
	// });
	return result
}

var retryCount = 0;
var checkRefreshToken = function(config) {
	var refresh_token = getVal("refresh_token");
	//刷新令牌存在
	if (refresh_token) {
		var access_token = getVal("access_token");
		var access_token_exprie = parseInt(getVal("token_access_token_exprie"));
		//访问令牌存在  同时没过期
		if (access_token) { // &&  (access_token_exprie - new Date().getTime()) > 30 * 1000) { //过期时间大于30秒
			//设置头部
			config.headers["Authorization"] = 'Bearer ' + access_token;
			//设置企业编码
			config.headers["userCompany"] = getVal('curCompany').id;

		} else {
			//刷新访问令牌   同步请求
			var xhr = new XMLHttpRequest();
			xhr.open("POST", basePath + "/amc/oauth2/token?grant_type=refresh_token&refresh_token=" + refresh_token, false); // 同步请求
			xhr.setRequestHeader("Authorization", "Basic YXBwOmFwcA==");
			xhr.send(null);
			if (xhr.responseText) {
				var result = JSON.parse(xhr.responseText)
				if (result.error) { //出现错误 重新登录
					uni.setStorageSync("access_token", ""); //访问令牌
					uni.setStorageSync("token_access_token_exprie", ""); //访问令牌有效时间
					uni.setStorageSync("refresh_token", ""); //刷新令牌
					//跳转登录
					uni.navigateTo({
						url: '/pages/login/login'
					});
				} else {
					//登录成功放入令牌，放入头部
					uni.setStorageSync("token_access_token_exprie", new Date().getTime() + parseInt(result.expires_in) * 1000);
					uni.setStorageSync("access_token", result.access_token)
					config.headers["Authorization"] = 'Bearer ' + result.access_token;
				}
			}
		}
	} else {
		//跳转登录
		// uni.navigateTo({
		// 	url: '/pages/login/login'
		// });
		uni.showModal({
			content: '登录信息过期，请重新登录',
			showCancel: false
		});
	}
}
//------------------- 一、请求拦截器 忽略
instance.interceptors.request.use(function(config) {
	// console.log("请求拦截器")
	//放入头部格式
	config.headers["Content-Type"] = "application/json;charset=UTF-8";
	if (config.url.indexOf("/api/open") == -1 && config.url.indexOf("/password/token") === -1 && config.url.indexOf("/phone/token") == -1 && config.url.indexOf("logout") == -1) {
		//验证令牌并放入头部信息
		var access_token = getVal("access_token");
		config.headers["Authorization"] = 'Bearer ' + access_token;
	}
	if (config.url.indexOf("/password/token") !== -1 || config.url.indexOf("/phone/token") !== -1 || config.url.indexOf("logout") !== -1 || config.url.indexOf("/dingCode/token") !== -1 || config.url.indexOf("/api/open/ding/getdingDingUserId") !== -1) {
		config.headers["Authorization"] = "Basic YXBwOmFwcA=="
	}
	if (getVal('curCompany')) {
		if (getVal('curCompany').id) {
			config.headers["userCompany"] = getVal('curCompany').id
		} else {
			config.headers["userCompany"] = JSON.parse(getVal('curCompany')).id
		}
	}
	if (getVal('user_id')) {
		config.headers["Userid"] = getVal('user_id')
	}

	//拼接接口国际化参数
	// if(config.url.indexOf(config.langCode)!=-1){
	// 	var splicingSymbol = '?'
	// 	if (config.url.indexOf("?") > 0) {
	// 		splicingSymbol = '&'
	// 	}
	// 	config.url += splicingSymbol + config.langCode + '=' + config.lang
	// }
	return config;
}, function(error) {
	// 对请求错误做些什么
	return Promise.reject(error);
});
//----------------- 二、响应拦截器 忽略
instance.interceptors.response.use(function(response) {
	return response.data;
}, function(error) {
	console.log(error, 'error')
	if (error && error.message && error.message.indexOf('timeout') != -1) {
		uni.showToast({
			title: '网络超时',
			icon: 'none',
			duration: 2000
		});
		return;
	}
	if (error && error.message && error.message.indexOf('Network Error') != -1) {
		uni.showToast({
			title: '请检查网络设置',
			icon: 'none',
			duration: 2000
		});
		return;
	}
	//令牌过期
	if (error.response && error.response.data.error == 'invalid_token') {
		uni.setStorageSync("access_token", ""); //访问令牌
		uni.setStorageSync("token_access_token_exprie", ""); //访问令牌有效时间
		// 如果是H5页面，过期直接跳转登录页
		// if (window.navigator.userAgent.toLowerCase().match(/micromessenger/i) != 'micromessenger' && !window.plus) {
		/*获取当前页面的地址用于跳转到登陆页面后在跳回页面*/
		// let pages = getCurrentPages() // 获取栈实例
		// let page = pages[pages.length - 1] // 获取当前页面的数据，包含页面路由
		// let fullPath = page.__page__.fullPath;
		// if(fullPath.indexOf("/pages/login/login")==-1){
		// 	/*访问的路由*/
		// 	uni.setStorageSync("visit_route", fullPath);
		// }
		uni.reLaunch({
			url:"/pages/login/login"
		})
		// uni.navigateTo({
		// 	url: "/pages/login/login"
		// })
		// return
		// }
		//通知app刷新令牌
		// refreshToken(success => {},
		// 	fail => {}
		// );
		// retryCount++;
		// if (retryCount < 2) {
		// 	return instance.request(error.response.config); //重新发起请求
		// } else {
		// 	return;
		// }
	}


	//无效企业ID
	if (error.response && error.response.data.status === 12021) {
		uni.showToast({
			title: '无效企业编码',
			icon: 'none',
			duration: 2000
		});
	} else if (error.response && error.response.data.message.indexOf('BAD_GATEWAY') != -1) {
		uni.showToast({
			title: '正在重启服务器，请稍候',
			icon: 'none',
			duration: 2000
		});
	} else if (error.message.indexOf('404') != -1) {
		uni.showToast({
			title: '请求地址不存在',
			icon: 'none',
			duration: 2000
		});
	} else if (error.response) {
		return error.response.data;
	} else {
		return;
	}
	return Promise.reject(error);
});
// 通知app刷新令牌
function refreshToken(success, fail) {
	if (window.plus) {
		uni.webView.postMessage({
			data: {
				action: 'refreshToken'
			}
		});
		var num = 0;
		var inter = setInterval(function() {
			num++;
			if (num > 600) {
				clearInterval(inter)
			}
			// var a = plus.storage.getItem("wvScanResult")
			// var b = plus.storage.getItem("wvScanResultFail")
			if (a) {
				if (success) {
					success(a)
				}
				// plus.storage.setItem("wvScanResult", "")
				clearInterval(inter)
			}
			if (b) {
				// plus.storage.setItem("wvScanResultFail", "")
				clearInterval(inter)
				if (fail) {
					fail(b)
				}
			}
		}, 100)
	} else {
		console.log("not plus")
	}
}




/**
 * 使用es6的export default导出了一个函数，导出的函数代替axios去帮我们请求数据，
 * 函数的参数及返回值如下：
 * @param {String} url     请求的url:
 * @param {String} method  请求的方法：get、post、delete、put
 * @param {Object} data    请求的参数
 * @returns {Promise}     返回一个promise对象，其实就相当于axios请求数据的返回值
 */
export default function(url, method, data = null, callback) {
	method = method.toLowerCase();
	if (method == 'post') {
		return new Promise((resolve, reject) => {
			instance.post(url, data).then(res => {
				resolve(res)
				callback(res)
			}).catch(err => {
				reject(err)
			})

		})
	} else if (method == 'get') {
		return new Promise((resolve, reject) => {
			instance.get(url, {
				params: data
			}).then(res => {
				resolve(res)
				callback(res)
			}).catch(err => {
				reject(err)
			})
		})
	} else if (method == 'delete') {
		return new Promise((resolve, reject) => {
			instance.delete(url, {
				params: data
			}).then(res => {
				resolve(res)
				callback(res)
			}).catch(err => {
				reject(err)
			})
		})
	} else if (method == 'put') {
		return new Promise((resolve, reject) => {
			instance.put(url, data).then(res => {
				resolve(res)
				callback(res)
			}).catch(err => {
				reject(err)
			})
		})
	} else if (method == 'patch') {
		return new Promise((resolve, reject) => {
			instance.patch(url, data).then(res => {
				resolve(res)
				callback(res)
			}).catch(err => {
				reject(err)
			})
		})
	} else {
		console.error('未知的method' + method)
	}
}